import api from './config';

export const getInvitations         = ()           => api.get('/invitations').then(r => r.data);
export const getEmployeeAccess      = (employeeId) => api.get(`/invitations/employee/${employeeId}`).then(r => r.data);
export const createInvitation       = (data)       => api.post('/invitations', data).then(r => r.data);
export const resendInvitation       = (id)         => api.post(`/invitations/${id}/resend`).then(r => r.data);
export const cancelInvitation       = (id)         => api.post(`/invitations/${id}/cancel`).then(r => r.data);

export const unlinkEmployee         = (employeeId) => api.post(`/invitations/employee/${employeeId}/unlink`).then(r => r.data);

// Endpoints públicos (sin auth)
export const validateToken          = (token)      => api.get(`/invitations/activate/${token}`).then(r => r.data);
export const activateAccount        = (data)       => api.post('/invitations/activate', data).then(r => r.data);
